import { render, staticRenderFns } from "./Last24HourCountdown.vue?vue&type=template&id=4047f503&scoped=true&"
import script from "./Last24HourCountdown.vue?vue&type=script&lang=js&"
export * from "./Last24HourCountdown.vue?vue&type=script&lang=js&"
import style0 from "./Last24HourCountdown.vue?vue&type=style&index=0&id=4047f503&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047f503",
  null
  
)

export default component.exports